import React from 'react';
import './styles.css';
import BandwidthWarning from '../BandwidthWarning';
import useIsTrackSwitchedOff from '../../hooks/useIsTrackSwitchedOff';
import usePublications from '../../hooks/usePublications';
import useTrack from '../../hooks/useTrack';
import MicOff from '../../icons/MicOff';
import ParticipantConnectionIndicator from '../ParticipantConnectionIndicator';
import useParticipantNetworkQualityLevel from '../../hooks/useParticipantNetworkQualityLevel';
import NetworkQualityLevel from '../NetworkQualityLevel';
import useVideoContext from '../../hooks/useVideoContext';
import useIsTrackEnabled from '../../hooks/useIsTrackEnabled';
import { useVideoRoomI18nProvider, VideoRoomI18nMessage } from '../../components/VideoRoomI18n';
import useAudioVolume from '../../hooks/useAudioVolume';
import AudioLevelIndicator from '../AudioLevelIndicator';
import AppInfoDisplay from '../AppInfoDisplay';
import { MainGreen, WarningRed } from '../../utils/colors';
import ProfileAvatar from "../ProfileAvatar";
export default function Index(_ref) {
  var participant = _ref.participant,
      _ref$showOverlays = _ref.showOverlays,
      showOverlays = _ref$showOverlays === void 0 ? false : _ref$showOverlays,
      children = _ref.children;

  var _useVideoContext = useVideoContext(),
      localParticipant = _useVideoContext.room.localParticipant,
      onSpeakerEvent = _useVideoContext.onSpeakerEvent,
      participantsInfo = _useVideoContext.participantsInfo,
      themeOptions = _useVideoContext.themeOptions;

  var _useVideoRoomI18nProv = useVideoRoomI18nProvider(),
      format = _useVideoRoomI18nProv.format;

  var publications = usePublications(participant);
  var videoPublication = publications.find(function (p) {
    return p.trackName.includes('camera');
  });
  var screenSharePublication = publications.find(function (p) {
    return p.trackName.includes('screen');
  });
  var networkQualityLevel = useParticipantNetworkQualityLevel(participant);
  var videoTrack = useTrack(screenSharePublication || videoPublication);
  var isVideoEnabled = useIsTrackEnabled(videoTrack);
  var audioPublication = publications.find(function (p) {
    return p.kind === 'audio';
  });
  var audioTrack = useTrack(audioPublication);
  var isAudioEnabled = useIsTrackEnabled(audioTrack);
  var isLocalParticipant = localParticipant === participant;
  var firstName = !isLocalParticipant ? participantsInfo.remoteName.split(' ')[0] : null;
  var fullName = !isLocalParticipant ? participantsInfo.remoteName : null;
  var audioMuteMessage = !isLocalParticipant ? format(VideoRoomI18nMessage.remote_muted_audio, {
    name: firstName
  }) : format(VideoRoomI18nMessage.local_muted_audio);

  var onVolumeChange = function onVolumeChange(volumeAvg, volumeMax) {
    onSpeakerEvent && onSpeakerEvent({
      event: 'volume',
      value: volumeMax,
      participantSid: participant.sid,
      participantIdentity: participant.identity,
      isLocal: false
    });
  };

  var volume = useAudioVolume(audioTrack, participant, !isLocalParticipant ? onVolumeChange : null);

  var buildMessagesStyle = function buildMessagesStyle() {
    var style = {
      borderRadius: themeOptions.userDefined.statusMessageRadius
    };

    if (!isLocalParticipant) {
      style.backgroundColor = themeOptions.userDefined.statusMessageBGColor;
    } else if (!isAudioEnabled) {
      style.backgroundColor = WarningRed;
    }

    return style;
  };

  var isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack);
  return /*#__PURE__*/React.createElement("div", {
    id: "MainParticipantInfo.container",
    className: "main-participant-info__container " + (isVideoSwitchedOff ? 'video-switched--off' : '')
  }, /*#__PURE__*/React.createElement("div", {
    id: "MainParticipantInfo.infoContainer",
    className: "main-participant-info__container__info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "status-messages " + (isAudioEnabled && 'status-messages--empty'),
    style: buildMessagesStyle()
  }, audioTrack && !isAudioEnabled && [/*#__PURE__*/React.createElement("h4", {
    key: "mute-message"
  }, audioMuteMessage), /*#__PURE__*/React.createElement(MicOff, {
    key: "mute-icon",
    style: {
      width: '24px',
      height: '24px'
    }
  })]), /*#__PURE__*/React.createElement(NetworkQualityLevel, {
    qualityLevel: networkQualityLevel
  })), isVideoSwitchedOff && /*#__PURE__*/React.createElement(BandwidthWarning, null), !isVideoEnabled && /*#__PURE__*/React.createElement("div", {
    className: "video--off__message"
  }, /*#__PURE__*/React.createElement(ProfileAvatar, {
    initials: participantsInfo.remoteInitials,
    avatar: participantsInfo.remoteAvatar
  })), children, /*#__PURE__*/React.createElement("div", {
    className: "aux-info__container " + (showOverlays ? 'show-overlays' : '')
  }, fullName && /*#__PURE__*/React.createElement(AppInfoDisplay, {
    name: fullName
  }), /*#__PURE__*/React.createElement(AudioLevelIndicator, {
    volume: volume
  })));
}